import Vue from 'vue';
import table from '../../components/ins-manage/ins-table.vue';
import { download, saveExportFile } from './down-util.ts';
import { policyTypeOptions, policyOperOptions } from './ins-order-const.ts';
import { queryChannelInfo } from './ins-utils.ts';
import eventBus from '../../utils/fresh-table';
import dlgOrderDetail from './dlg-order-detail.vue';
export default Vue.extend({
    components: {
        'el-order-list': table,
        'el-dialog-detail': dlgOrderDetail,
    },
    data: function () {
        var _this = this;
        return {
            downLoading: false,
            otherParam: {
                channelId: '',
            },
            requestConfig: {
                url: '/proxy/carInsOrder/dfs/policy/items',
                method: 'post',
            },
            searchConfig: [
                {
                    label: '车牌号',
                    key: 'plateNo',
                    type: 'input',
                    clearable: true,
                    placeholder: '请输入车牌号',
                },
                {
                    label: '保单号',
                    key: 'policyNo',
                    type: 'input',
                    clearable: true,
                    placeholder: '请输入保单号',
                },
                {
                    label: '险种',
                    type: 'select',
                    key: 'policyType',
                    clearable: true,
                    option: policyTypeOptions,
                },
                {
                    label: '保单类型',
                    type: 'select',
                    key: 'operateType',
                    clearable: true,
                    option: policyOperOptions,
                },
                {
                    label: '投保城市',
                    type: 'selectCity',
                    key: 'insuranceCityCode',
                    clearable: true,
                },
                {
                    label: '签单日期',
                    key: 'createDateRange',
                    type: 'dateRangeArr',
                    clearable: false,
                    pickerOptions: {
                        disabledDate: function (time) {
                            return time.getTime() > Date.now();
                        },
                    },
                },
                {
                    label: '保单起期',
                    key: 'insuranceBeginDateRange',
                    type: 'dateRangeArr',
                    clearable: false,
                },
            ],
            defaultSearch: {},
            mutexDisableParam: {
                closeMutex: true,
            },
            tableConfig: [
                {
                    label: '保单号',
                    prop: 'policyNo',
                    tooltip: true,
                    width: '206px',
                },
                {
                    label: '批单号',
                    prop: 'endorseNo',
                    tooltip: true,
                    width: '130px',
                },
                {
                    label: '保单类型',
                    prop: 'operateType',
                    tooltip: true,
                    width: '100px',
                    formatter: function (val) {
                        // UNDERWRITE("承保"), CORRECT("批改"), CANCEL("退保");
                        var name = '';
                        switch (val) {
                            case 'UNDERWRITE':
                                name = '承保';
                                break;
                            case 'CORRECT':
                                name = '批改';
                                break;
                            case 'CANCEL':
                                name = '退保';
                                break;
                            default:
                                name = '--';
                                break;
                        }
                        return name;
                    },
                },
                {
                    label: '险种',
                    prop: 'policyTypeName',
                    tooltip: true,
                    width: '130px',
                },
                {
                    label: '保险公司',
                    prop: 'insCompanyName',
                    tooltip: true,
                    width: '240px',
                },
                {
                    label: '保费',
                    prop: 'premiumFee',
                    tooltip: true,
                    width: '110px',
                },
                {
                    label: '投保城市',
                    prop: 'insuranceCityName',
                    tooltip: true,
                    width: '100px',
                },
                {
                    label: '车牌号',
                    prop: 'plateNo',
                    tooltip: true,
                    width: '120px',
                },
                {
                    label: '投保人',
                    prop: 'applicantName',
                    tooltip: true,
                    width: '160px',
                },
                {
                    label: '被保险人',
                    prop: 'insurantName',
                    tooltip: true,
                    width: '160px',
                },
                {
                    label: '保险起期',
                    prop: 'insuranceBeginTime',
                    tooltip: true,
                    width: '128px',
                },
                {
                    label: '保险止期',
                    prop: 'insuranceEndTime',
                    tooltip: true,
                    width: '128px',
                },
                {
                    label: '签单日期',
                    prop: 'createTime',
                    tooltip: true,
                    width: '128px',
                },
                {
                    label: '操作',
                    prop: 'ope_control_group',
                    minWidth: '90px',
                    fixed: 'right',
                    btns: [
                        {
                            name: '查看',
                            callback: function (row) {
                                _this.showDetail(row);
                            },
                        },
                    ],
                },
            ],
            insOrderInfo: {},
        };
    },
    methods: {
        exportOrders: function () {
            var _this = this;
            var url = '/proxy/carInsExport/dfs/policy/export';
            var params = this.$refs.insOrderTable.getParams();
            params.serverType = 1;
            this.downLoading = true;
            download(url, params)
                .then(function (res) {
                _this.downLoading = false;
                var ts = new Date().getTime();
                var fileName = "\u4FDD\u5355_" + ts + ".xls";
                saveExportFile(fileName, res);
                return res;
            })
                .catch(function () {
                _this.downLoading = false;
                _this.$message({
                    message: '保单下载失败',
                    type: 'error',
                });
            });
        },
        transRespData: function (resp) {
            var _a = resp.data.pageInfo, totalElements = _a.totalElements, pageNumber = _a.pageNumber, pageSize = _a.pageSize;
            var curResp = {
                data: resp.data.policyItems,
                totalItemCount: totalElements,
                pageSize: pageSize,
                pageNo: pageNumber,
            };
            Object.assign(resp, curResp);
        },
        beforeSearchFunc: function () {
            if (!this.otherParam.channelId) {
                return false;
            }
            return true;
        },
        showDetail: function (row) {
            var _this = this;
            var params = {
                policyId: row.policyId,
            };
            return this.$request({
                url: '/proxy/carInsOrder/dfs/policy/detailById',
                method: 'get',
                data: params,
            }).then(function (res) {
                if (!res) {
                    return;
                }
                if (res.errorCode || !res.data) {
                    return;
                }
                _this.insOrderInfo = {};
                if (res.data.policyInfo) {
                    Object.assign(_this.insOrderInfo, res.data.policyInfo);
                }
                if (res.data.insurantInfo) {
                    Object.assign(_this.insOrderInfo, res.data.insurantInfo);
                }
                if (res.data.applicantInfo) {
                    Object.assign(_this.insOrderInfo, res.data.applicantInfo);
                }
                if (res.data.vehicleInfo) {
                    var _a = res.data.vehicleInfo, vehicleType = _a.vehicleType, vehicleUseType = _a.vehicleUseType;
                    var vehicleTypeName = vehicleType === '02' ? '旧车' : '新车';
                    var vehicleUseTypeName = vehicleUseType === '02' ? '营运车' : '非营运车';
                    res.data.vehicleInfo.vehicleTypeName = vehicleTypeName;
                    res.data.vehicleInfo.vehicleUseTypeName = vehicleUseTypeName;
                    Object.assign(_this.insOrderInfo, res.data.vehicleInfo);
                }
                _this.$refs.dlgDetail.showSelf();
            });
        },
    },
    mounted: function () {
        var _this = this;
        queryChannelInfo().then(function (resp) {
            if (resp && resp.id) {
                _this.otherParam.channelId = resp.id;
                eventBus.$emit('freshTable');
            }
        });
    },
});
